
import React, { useContext } from "react";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faLocationPin, faPencil } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom";
import { ACCESS_LEVEL_ADMIN, VENDOR_EDIT_URL, BASE_TITLE } from "../../utlities/core.constants";

// import { VendorContext } from "./VendorContext";
import "./VendorOverview.page.scss";
import { UserContext } from "../UserContext";
import { PageSubHeader, SectionSubHeader } from "../shared.styled";

import ProductTableContainer from "../Product/ProductList/ProductTableContainer.component";
import { formatPrimaryPoc } from "../../utlities/common.funcs";

function EditButton({ label }) {
  return <Link className="no-underline" to={VENDOR_EDIT_URL} aria-label={label}>
    <FontAwesomeIcon className="text-xl" icon={faPencil} aria-hidden="true" />&nbsp;
    <span className="underline text-sm">Edit page</span>
  </Link>
}

export default function VendorDetail({ entity, primaryPoc, myListings = false }) {
  const { checkEntityAccessLevel, pocAddressFieldsEmpty, user } = useContext(UserContext);

  document.title = `${BASE_TITLE} - Vendor Overview`;

  const editingAgency = Boolean(user?.agencyId && user.agencyId === entity?.id);
  const editLabel = editingAgency ? "Edit agency overview page" : "Edit vendor overview page";

  return (<>
    <PageSubHeader>
      {entity?.name} Overview &nbsp; {(user.vendorId === entity.id || user.agencyId === entity.id) && checkEntityAccessLevel([ACCESS_LEVEL_ADMIN]) ? <EditButton label={editLabel} /> : null}
    </PageSubHeader>

    <div className="grid grid-cols-12 gap-8">
      <div className="col-span-8">
        <p className="leading-normal whitespace-pre-wrap">{entity?.description}</p>
      </div>
      <div className="col-span-4">
        <div className="px-8 py-4 rounded-sm bg-accent-cool-lighter/30">
          <h3 className="h3-reg text-primary-darker inline-block mb-2 mt-0">Get In Touch</h3>
          <div>
            <div className="flex [&>span]:block [&>span:last-child]:flex-1">
              <span className="text-accent-cool mr-4"><FontAwesomeIcon icon={faPhone} aria-hidden="true" /></span>
              <span className="text-primary-darker"><span className="font-semibold">Phone: </span>{primaryPoc?.phoneNumber ? primaryPoc.phoneNumber : "N/A"}</span>
            </div>
            <div className="flex [&>span]:block [&>span:last-child]:flex-1">
              <span className="text-accent-cool mr-4"><FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />  </span>
              <span className="text-primary-darker"><span className="font-semibold">Email: </span>{primaryPoc?.email ? primaryPoc.email : "N/A"}</span>
            </div>
            <div className="flex [&>span]:block [&>span:last-child]:flex-1">
              <span className="text-accent-cool mr-4"><FontAwesomeIcon icon={faLocationPin} aria-hidden="true" /></span>
              <span className="text-primary-darker"><span className="font-semibold">Address: </span>{pocAddressFieldsEmpty(primaryPoc) ? "N/A" : formatPrimaryPoc(primaryPoc?.street1, primaryPoc?.street2, primaryPoc?.city, primaryPoc?.state, primaryPoc?.zipCode)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    {myListings ? null : (
      <>
        <SectionSubHeader className="font-normal">{entity?.name}&apos;s product ACR listings</SectionSubHeader>
        <p className="leading-normal text-primary-darker">Use the filters below to narrow down your search.
          You can apply several filters at a time, as well as
          filter by the different categories at the same time.
          Once filters are applied, you can remove them by clicking
          on the “X” next to each filter name
        </p>
      </>
    )}
    <div className={myListings ? "mt-10" : undefined}>
      <ProductTableContainer entityId={entity.id} myListings={myListings} />
    </div>
  </>
  );
}

EditButton.propTypes = {
  label: PropTypes.string.isRequired
}

VendorDetail.propTypes = {
  entity: PropTypes.object.isRequired,
  primaryPoc: PropTypes.object.isRequired,
  myListings: PropTypes.bool
}
